export function installChecklistPatches(): void {
  const reorder = () => {
    try {
      const state = window.beatlineState || window.state || null;
      const turn = Number((state && (state.turn || state.currentPlayer)) || 0);
      if (!turn) return;
      for (let i = 1; i <= 4; i++) {
        const zone = document.getElementById(`zone-p${i}`);
        if (!zone) continue;
        zone.style.order = i === turn ? '0' : String(i + 1);
        zone.classList.toggle('active', i === turn);
        zone.classList.toggle('active-player', i === turn);
      }
    } catch (_) {}
  };
  window.addEventListener('beatline_data_loaded', reorder);
  document.addEventListener('click', () => setTimeout(reorder, 0), true);
  window.setInterval(reorder, 600);

  const syncVisualizer = () => {
    const app = document.getElementById('beatline-app');
    const vis = document.getElementById('vis-anim');
    const notes = document.getElementById('notes-anim');
    const isPlaying = !!app?.classList.contains('is-playing');
    if (vis) vis.style.visibility = isPlaying ? 'visible' : 'hidden';
    if (notes) notes.setAttribute('aria-hidden', isPlaying ? 'false' : 'true');
  };
  const observer = new MutationObserver(syncVisualizer);
  const start = () => {
    const app = document.getElementById('beatline-app');
    if (app) observer.observe(app, { attributes: true, attributeFilter: ['class'] });
    syncVisualizer();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
}
